import { createContext } from 'react'

export type Config = {
  elationBaseUrl: string
  // Where copied record links point when the host is not Portal itself;
  // absent, links use the current origin.
  portalOrigin?: string
  // Restricts native controls to read-only for an embedding host, on top of
  // the access policy and auditor checks.
  readOnly?: boolean
  // TipTap's `immediatelyRender` for rich text that leaves it unset: false
  // under server rendering (Next.js), which must defer editor creation to the
  // client. Absent, TipTap's own default.
  immediatelyRenderForSSR?: boolean
}

export const ConfigContext = createContext<Config | null>(null)
